// UI visibility only; backend permissions are managed separately.
export function isTerminalPaymentHistoryEnabled(value) {
  return !['0', 'false', 'off', 'no'].includes(String(value ?? '').trim().toLowerCase());
}

export const TERMINAL_PAYMENT_HISTORY_ENABLED = isTerminalPaymentHistoryEnabled(
  process.env.REACT_APP_TERMINAL_PAYMENT_HISTORY_ENABLED,
);
